<template>
  <div id="content">
    <div is="sui-container">
      <sui-dimmer v-if="pageLoading" active>
        <sui-loader content="Loading..." />
      </sui-dimmer>
      <sui-modal v-model="open" size="tiny">
        <sui-modal-content>
          <h3 v-if="passedStatus" is="sui-header" text-align="center">{{passedText}}</h3>
          <h3 v-else is="sui-header" text-align="center">{{failText}}</h3>
          <div class="ui aligned basic segment ">
            <sui-grid v-if="passedStatus">
              <sui-grid-column :width="1">
              </sui-grid-column>
              <sui-grid-column :width="14">
                <form class="ui form" @submit.prevent="sendContacts()">
                  <div class="field">
                    <div class="ui left icon input input-form" :class="{ 'error': submitted && $v.user.name.$error }">
                      <i class="user icon"></i>
                      <input type="text" 
                             placeholder="Username" 
                             autocomplete="off" 
                             v-model="user.name"
                             :class="{ 'error': submitted && $v.user.name.$error }">
                    </div>
                    <div v-if="submitted && !$v.user.name.required" class="invalid-feedback error-font">Username is required</div>
                    <div v-else class="invalid-feedback"></div>
                  </div>
                  <div class="field">
                    <div class="ui left icon input input-form" :class="{ 'error': submitted && $v.user.telegram.$error }">
                      <input type="text" 
                             placeholder="Telegram" 
                             autocomplete="off" 
                             v-model="user.telegram"
                             :class="{ 'error': submitted && $v.user.telegram.$error }">
                      <i class="telegram icon"></i>
                    </div>
                    <div v-if="submitted && !$v.user.telegram.required" class="invalid-feedback error-font">Telegram is required</div>
                    <div v-else class="invalid-feedback"></div>
                  </div>
                  <div class="field">
                    <div class="ui left icon input input-form" :class="{ 'error': submitted && $v.user.email.$error }">
                      <input 
                             placeholder="Email" 
                             autocomplete="off"
                             v-model="user.email"
                             :class="{ 'error': submitted && $v.user.email.$error }">
                      <i class="mail icon"></i>
                    </div>
                      <div v-if="submitted && $v.user.email.$error" class="invalid-feedback">
                        <span class="error-font" v-if="!$v.user.email.required">Email is required</span>
                        <span class="error-font" v-if="!$v.user.email.email">Email is invalid</span>
                      </div>
                      <div v-else class="invalid-feedback"></div>
                  </div>
                  <div class="field submit-row">
                    <sui-button type="submit" v-if="passedStatus" color="green" class="send">Send</sui-button>
                  </div>
                </form>
                  <sui-button primary class="back" @click="closeModal()">Back</sui-button>
              </sui-grid-column>
              <sui-grid-column :width="1">
              </sui-grid-column>
            </sui-grid>
          </div>
        </sui-modal-content>
        <sui-modal-actions v-if="!passedStatus">
          <sui-button primary  class="cwidth" @click="closeModal()">Back</sui-button>
        </sui-modal-actions>
      </sui-modal>
      <div v-if="APIError">
        <sui-message icon="times circle" error>
          <sui-message-header>Service is temporarily unavailable</sui-message-header>
        </sui-message>
      </div>
      <div v-else-if="!demoMode">
        <transition name="fade">
          <sui-message
            warning
            v-if="bannerVisible"
            header="Hint:"
            content="Command line arguments are not allowed."
            dismissable
            @dismiss="bannerHandleDismiss"
          />
        </transition>
        <div class="header-buttons">
          <div class="logo-div">
            <img class="logo-img" src="../assets/awk_logo.png">
          </div>
          <div class="task-buttons-div">
            <button v-for="(task, index) in tasks"
                    v-bind:key="index"
                    class="ui primary button tasks"
                    :active="isActive(index)"
                    :id="index"
                    @click="select(index)">Task #{{index}}</button>
          </div>
          <div class="finish-div" >
            <sui-button color="green" class="finish" v-on:click="finish">Finish</sui-button>
          </div>
        </div>
        <div ref="takeSize">
          <div v-for="(task, index) in tasks"  v-bind:key="index" >
            <sui-segment v-if="active === index" > 
              <sui-grid >
                <sui-grid-row>
                  <sui-grid-column :width="16">
                    <sui-grid class="greed-padding">
                        <div class="input-width">
                          <sui-input class="green" :id="index" v-model="task.expression" @keyup.enter="process(index, 1)"/>
                        </div>
                        <div class="try-done-width">
                          <sui-button primary class="try" v-on:click="process(index, 1)">Try</sui-button>
                          <sui-button color="green" class="donebtn" v-on:click="process(index, 2)">Done</sui-button>
                        </div>
                    </sui-grid>
                  </sui-grid-column>
                </sui-grid-row>
                <sui-grid-row class="gold">
                  <div class="tasks-segment left ow">
                    <pre class="pre-text">{{ task.in }}</pre>
                  </div>
                  <div class="tasks-segment right ow">
                    <pre class="pre-text" v-if="task.is_exp">{{ task.out }}</pre>
                    <pre class="pre-text" v-else>{{ task.userOut }}</pre>
                  </div>
                  <div class="expected">
                    <div class="exp-toggle-div"><label class="exp-toggle" > As is</label></div>
                    <div class="exp-toggle-div"><sui-checkbox toggle v-model="task.is_exp"/></div>
                    <div><label class="exp-toggle"> As expected</label></div> 
                  </div>
                </sui-grid-row>
              </sui-grid>
              <transition name="fade">
                <div  v-if="showDescription" class="description-wrapper" align="center">
                  <sui-segment class="description">
                    <div class="pre-div" align="left">
                      <pre class="gold-two pre-description">{{task.description}}</pre>
                      <sui-button primary class="description" v-on:click="showDescription = !showDescription">Got it!</sui-button>
                    </div>
                  </sui-segment>
                </div>
              </transition>
            </sui-segment>
          </div>
        </div>
      </div>
      <!-- DEMO ELEMENTS -->
      <div v-else-if="demoMode">
        <div class="demo-wrapper"></div>
        <transition name="demoFade">
          <div v-if="showHighlight" class="highlight-wrapper">
            <div class="highlight-inner-button"></div>
            <!-- <div class="highlight-inner-text"></div> -->
          </div>
        </transition>
        <transition v-if="showBlack" name="demoFade">
          <div class="black-wrapper">
          </div>
        </transition>
        <sui-button color="red" class="stop-demo-btn" v-on:click="stopDemo">Stop Demo</sui-button>
        <div class="header-buttons">
          <div class="logo-div">
            <img class="logo-img" src="../assets/awk_logo.png">
          </div>
          <div class="task-buttons-div">
            <button v-for="(task, index) in demoTasks"
                    v-bind:key="index"
                    class="ui primary button tasks"
                    :activeDemo="isActiveDemo(index)"
                    :id="'demo' + index"
                    >Task #{{index}}</button>
          </div>
          <div class="finish-div" >
            <sui-button color="green" class="finish" v-on:click="finish">Finish</sui-button>
          </div>
        </div>
        <div ref="takeSize">
          <div v-for="(task, index) in demoTasks"  v-bind:key="index" >
            <sui-segment v-if="activeDemo === index" > 
              <sui-grid >
                <sui-grid-row>
                  <sui-grid-column :width="16">
                    <sui-grid class="greed-padding">
                        <div class="input-width">
                          <sui-input class="green" v-model="task.expression"/>
                        </div>
                        <div class="try-done-width">
                          <sui-button primary class="try">Try</sui-button>
                          <sui-button color="green" class="donebtn">Done</sui-button>
                        </div>
                    </sui-grid>
                  </sui-grid-column>
                </sui-grid-row>
                <sui-grid-row class="gold">
                  <div class="tasks-segment left ow">
                    <pre class="pre-text" v-html="task.in">{{ task.in }}</pre>
                  </div>
                  <div class="tasks-segment right ow">
                    <pre class="pre-text" v-if="task.is_exp" v-html="task.out"></pre>
                    <pre class="pre-text" v-else v-html="task.userOut"></pre>
                  </div>
                  <div class="expected">
                    <div class="exp-toggle-div"><label class="exp-toggle" >As is</label></div>
                    <div class="exp-toggle-div"><sui-checkbox toggle v-model="task.is_exp"/></div>
                    <div><label class="exp-toggle"> As expected</label></div> 
                  </div>
                </sui-grid-row>
              </sui-grid>
              <transition name="fade">
                <div  v-if="showDescriptionDemo" class="description-wrapper" align="center">
                  <sui-segment class="description">
                    <div class="pre-div" align="left">
                      <pre class="gold-two pre-description">{{task.description}}</pre>
                      <sui-button primary class="description" id="show-demo-desc">Got it!</sui-button>
                    </div>
                  </sui-segment>
                </div>
              </transition>
            </sui-segment>
          </div>
        </div>
        <div id="cursor" class="cursor">
          <img src="../assets/cursor.png" class="cursor-img">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import API from '../libs/api'
import Demo from '../assets/js/demo.js'

import { required, email } from 'vuelidate/lib/validators'



export default {
  name: 'Content',
  data: () => {
    return {
      bannerVisible: true,
      showHighlight: false,
      showDescription: false,
      showDescriptionDemo: false,
      showBlack: false,
      APIError: false,
      sizeMassage: true,
      activeDemo: null,
      active: null,
      pageLoading: true,
      open: false,
      passedStatus: false,
      tasks: {},
      threshold: null,
      user : {
        name: '',
        email: '',
        telegram: ''
      },
      submitted: false,
      failText: 'Some tasks were not done correctly, try again',
      passedText: 'Congratulations, you have passed the test, leave your contacts and our HR will contact you',
      sizeText: 'The service will display incorrectly on your device. Please switch to desktop version',
      demoMode: true,
      demoTasks: { 
        1 : { 
          title: 'Demo1', 
          in: `2018.08.08 08:00:06 INFO hSVFd.Workers.Thread2 Connecting to 235.203.88......
2018.08.08 08:00:08 WARNING hSVFd.Workers.Thread2 Connection timed out / Could not connect to server
2018.08.08 08:00:08 INFO hSVFd.Workers.Thread2 Waiting to retry...
2018.08.08 08:00:10 INFO hSVFd.Workers.Thread2 Connecting to 235.203.88......
2018.08.08 08:00:11 INFO hSVFd.Workers.Thread2 Connection established, waiting for welcome message...
2018.08.08 08:10:10 ERROR hSVFd.DB Connection to DB Node1 Lost
2018.08.08 08:10:10 INFO hSVFd.DB Connecting to DB Node1`,
          out: '',
          userOut: '',
          goodOut: '2018.08.08 08:10:10 ERROR hSVFd.DB Connection to DB Node1 Lost',
          expression: '',
          expressionToWrite: '/ERROR/  { print $0 }',
          is_exp: true,
          status: false,
          weight: 1,
          description: 'Show only strings contains "ERROR"',
        }, 
        2: { 
          title: 'Demo2', 
          in: `93.74.93.2 - - [05:01:34 +00] "GET /pma/scripts/setup.php HTTP/1.1" 404 142 "-" "-"
93.74.93.2 - - [05:01:34 +00] "GET /phpadmin/scripts/setup.php HTTP/1.1" 404 142 "-" "-"
93.74.93.2 - - [05:01:34 +00] "GET /db/scripts/setup.php HTTP/1.1" 404 142 "-" "-"
93.74.93.2 - - [05:01:34 +00] "GET /myadmin/scripts/setup.php HTTP/1.1" 404 142 "-" "-"
93.74.93.2 - - [05:01:34 +00] "GET /php/phpmyadmin/scripts/setup.php HTTP/1.1" 404 142 "-" "-"`,
          out: '',
          goodOut: `/pma/scripts/setup.php <span class="highlite-span">404</span>
/phpadmin/scripts/setup.php <span class="highlite-span">404</span>
/db/scripts/setup.php <span class="highlite-span">404</span>
/myadmin/scripts/setup.php <span class="highlite-span">404</span>
/php/phpmyadmin/scripts/setup.php <span class="highlite-span">404</span>`,
          badOut: `/pma/scripts/setup.php <span class="highlite-span">142</span>
/phpadmin/scripts/setup.php <span class="highlite-span">142</span>
/db/scripts/setup.php <span class="highlite-span">142</span>
/myadmin/scripts/setup.php <span class="highlite-span">142</span>
/php/phpmyadmin/scripts/setup.php <span class="highlite-span">142</span>`,
          userOut: '',
          expression: '',
          expressionToWriteBad: '{print $7" "$10}',
          expressionToWriteGood1: '{print $7" "',
          expressionToWriteGood2: '$9}',
          is_exp: true,
          status: false,
          weight: 1,
          description: 'Show only url and error code columns',
        }
      }
    }
  },
  validations: {
    user: {
      name: {
        required
      },
      telegram: {
        required
      },
      email: {
        required,
        email
      }
    }
  },
  methods: {
    bannerHandleDismiss() {
      this.bannerVisible = false;
      // setTimeout(() => {
      //   this.visible = true;
      // }, 2000);
    },
    isActive(index) {
      return this.active === index
    },
    isActiveDemo(index) {
      return this.demoActive === index
    },
    select(index) {
      this.active = index
      if (!(index == this.active) || !this.showDescription) {
        this.showDescription = false
        setTimeout(() => this.showDescription = true, 20)
      }
    },
    process: function (id, type) {
      let int_id = parseInt(id, 10)
      let expression = this.tasks[int_id].expression
      API
      .process(int_id, expression)
      .then(data => {
        this.tasks[int_id].userOut = data['tasks'][0].userout
        this.tasks[int_id].status = data['tasks'][0].status
      })
      this.tasks[int_id].is_exp = false

      function ChangeButtonColor(id, status) {
          let taskButton = document.getElementById(id)
          taskButton.classList.remove('primary')
          taskButton.classList.remove('tasks')
          taskButton.classList.remove('green')
          taskButton.classList.remove('red')
          if (status) {
            taskButton.classList.add('green')
          } else {
            taskButton.classList.add('red')
          }
          taskButton.classList.add('done')
        }
      if (type === 2) {
        setTimeout(() => ChangeButtonColor(id, this.tasks[int_id].status), 100)
      }
    },
    processDemo: function (id, type, resType, color) {
      if (resType === 'good') {
        this.demoTasks[id].userOut = this.demoTasks[id].goodOut
      } else if (resType === 'bad') {
        this.demoTasks[id].userOut = this.demoTasks[id].badOut
      }
      
      this.demoTasks[id].is_exp = false
      if (type === 2) {
        let taskButton = document.getElementById('demo' + id)
        taskButton.classList.remove('primary')
        taskButton.classList.remove('tasks')
        taskButton.classList.add(color)
        taskButton.classList.add('done')
      }
    },
    is_expected: function(id) {
      let int_id = parseInt(id, 10)
      this.tasks[int_id].is_exp = !this.tasks[int_id].is_exp
    },
    closeModal: function() {
      this.open = false
      this.sizeMassage = false
    },
    writeExp: function(taskId, expressionToWrite, isEmpty) {
      let writeTimeOut = 200
      if (isEmpty) {
        this.demoTasks[taskId].expression = ''
      }
      for (let i in expressionToWrite) {
        setTimeout(() =>
          this.demoTasks[taskId].expression += expressionToWrite[i],
          writeTimeOut)
        writeTimeOut += 60
      }
    },
    ScrollTop: function() {
      Demo.ScrollWindow("0px")
    },
    ScrollBottom: function() {
      Demo.ScrollWindow("1000px")
    },
    demo: function() {
      if (!this.APIError) {
        this.demoTasks[1].expression = ''
        const time = 900
        let elemOffset = 15
        let desBtnPos = $('.ui.primary.button.description').offset()
        let inputPos = $('.ui.input').offset()
        let tryBtnPos = $('.ui.primary.button.try').offset()
        let DoneBtnPos = $('.ui.green.button.donebtn').offset()
        let task2Demo = $('.ui.primary.button.tasks').offset()
        let AsExpPos = $('.ui.fitted.toggle.checkbox').offset()
        let finishPos = $('.ui.green.button.finish').offset()
        // highlite ver
        let w = $(".ui.primary.button.tasks").css("width")
        let m = $(".ui.primary.button.tasks").css("margin-right")
        let tasksWidth = parseInt(w.substring(0, w.length - 2))
        let tasksMargin = parseInt(m.substring(0, m.length - 2))
        let highliteMargin = (150 - tasksWidth)/2
        let task2margin = tasksWidth + tasksMargin

        // TASK #1 SCENARIO
        Demo.myMove(elemOffset, elemOffset, desBtnPos, time, 1000)
        setTimeout(() => this.showDescriptionDemo = false, 1400)

        Demo.myMove(elemOffset + 10, elemOffset + 100, inputPos, time, 2000)
        setTimeout(() => this.writeExp(1, this.demoTasks[1].expressionToWrite, true), 3500)

        Demo.myMove(elemOffset, elemOffset, tryBtnPos, time, 900)
        setTimeout(() => this.processDemo('1', 1, 'good', 'green'), 6500)
        
        Demo.myMove(elemOffset, elemOffset, DoneBtnPos, time, 4900)

        setTimeout(() => this.showHighlight = true, 8000)
        setTimeout(() => Demo.setHighliteOffset(task2Demo, highliteMargin, 0), 8000)

        setTimeout(() => this.processDemo('1', 2, 'good', 'green'), 11000)
        setTimeout(() => this.showHighlight = false, 10000)
        // END TASK #1

        // TASK #2 SCENARIO (FAILED)
        Demo.myMove(elemOffset, elemOffset + 165, task2Demo, time, 900)
        setTimeout(() => this.activeDemo = Object.keys(this.demoTasks)[1], 14000)
        setTimeout(() => this.showDescriptionDemo = true, 14000)
        Demo.myMove(elemOffset, elemOffset, desBtnPos, time, 1000)
        setTimeout(() => this.showDescriptionDemo = false, 16000)
        
        Demo.myMove(elemOffset + 10, elemOffset + 100, inputPos, time, 2000)
        setTimeout(() => this.writeExp(2, this.demoTasks[2].expressionToWriteBad, true), 18000)

        Demo.myMove(elemOffset, elemOffset, tryBtnPos, time, 900)


        setTimeout(() => this.showHighlight = true, 22000)
        setTimeout(() => Demo.setHighliteOffset(task2Demo, highliteMargin, task2margin), 22000)

        setTimeout(() => this.processDemo('2', 1, 'bad', 'red'), 21000)
        setTimeout(() => this.showHighlight = false, 24000)
        setTimeout(() => this.demoTasks[2].out = this.demoTasks[2].goodOut, 21300)
        
        Demo.myMove(elemOffset, elemOffset, DoneBtnPos, time, 4900)
        setTimeout(() => this.processDemo('2', 2, 'bad', 'red'), 25300)
        setTimeout(() => $(".highlite-span").addClass('red'), 25300)
        // END TASK #2 SCENARIO (FAILED)

        // // TASK #2 SCENARIO (PASSED)
        Demo.myMove(elemOffset, elemOffset + 10, AsExpPos, time, 4000)
        Demo.delay(this.ScrollBottom, 27000)
        setTimeout(() => this.demoTasks[2].is_exp = true, 28000)
        setTimeout(() => this.demoTasks[2].is_exp = false, 30000)
        setTimeout(() => $(".highlite-span").addClass('red'), 30000)

        Demo.delay(this.ScrollTop, 32000)
        Demo.myMove(elemOffset + 10, elemOffset + 100, inputPos, time, 3000)
        setTimeout(() => this.writeExp(2, this.demoTasks[2].expressionToWriteGood1, true), 33000)
        setTimeout(() => this.writeExp(2, this.demoTasks[2].expressionToWriteGood2, false), 35000)

        Demo.myMove(elemOffset, elemOffset, tryBtnPos, time, 900)

        setTimeout(() => this.processDemo('2', 1, 'good', 'green'), 37000)
        setTimeout(() => $(".highlite-span").addClass('green'), 37000)
        Demo.myMove(elemOffset, elemOffset, DoneBtnPos, time, 3900)
        setTimeout(() => this.showHighlight = true, 38000)
        setTimeout(() => Demo.setHighliteOffset(task2Demo, highliteMargin, task2margin), 38000)
        setTimeout(() => this.processDemo('2', 2, 'good', 'green'), 41000)
        setTimeout(() => this.showHighlight = false, 40000)

        Demo.myMove(elemOffset, elemOffset, finishPos, time, 900)
        // END TASK #2 SCENARIO (PASSED)
        setTimeout(() => this.showBlack = true, 45000)
        setTimeout(() => this.demoMode = false, 45000)
        setTimeout(() => this.showDescriptionDemo = true, 45300)
      }
      
    },
    stopDemo: function() {
      setTimeout(() => this.showBlack = true, 500)
      setTimeout(() => this.demoMode = false, 500)
      setTimeout(() => this.showDescription = true, 800)
    },
    finish: function() {
      this.open = !this.open
      let total = 0
      Object.keys(this.tasks).forEach((key) => {
        const e = this.tasks[key]
        if (e.status) {
          total += e.weight
        }
      })
      if (total >= this.threshold) {
        this.passedStatus = true
        } else {
          this.passedStatus = false
        }
      },
    sendContacts: function() {
      this.submitted = true;
      this.$v.$touch()
      if (this.$v.$invalid) {
          return
      }
      let tasksResults = []
      Object.keys(this.tasks).forEach((key) => {
        const e = this.tasks[key]
        tasksResults.push({id: parseInt(key, 10), expression: e.expression})
      })
      const user = {
        name: this.user.name,
        email: this.user.email,
        telegram: this.user.telegram
      }
      API
        .results(tasksResults, user)
      this.open = !this.open
    },
    status(validation) {
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    },
  },
  mounted() {
    API
      .tasks()
      .then(data => {
        if (data === 'error') {
          this.APIError = true
        } else {
          this.threshold = data.threshold
          let tasks = {}
          Object.keys(data.tasks).forEach((key) => {
            const e = data.tasks[key]
            tasks[e.id] = { 
              title: 'Task #' + e.id, 
              in: e.in,
              out: e.out,
              userOut: '',
              expression: '',
              is_exp: true,
              status: false,
              weight: e.weight,
              description: e.description,
            }
          })
          this.tasks = tasks
          this.active = Object.keys(tasks)[0]
          this.activeDemo = Object.keys(this.demoTasks)[0]
        }
      })
      .finally(() => this.pageLoading = false)
      Demo.ResetCursor()
      setTimeout(() => this.showDescriptionDemo = true, 200)
      setTimeout(() => this.demo(), 2000)
      
  },
}
</script>
